<svg
  class="tag__ico"
  width="11px"
  height="17px"
  viewBox="0 0 11 17"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <g id="Assets" stroke="none" stroke-width="1" transform="translate(-342.000000, -156.000000)">
    <path
      d="M350.608543,156 L352.880253,156 L352.880253,173 L350.608543,173 C349.505623,173 348.451646,172.544605 347.695743,171.741459 L342.8154,166.556094 C341.7282,165.400944 341.7282,163.599056 342.8154,162.443906 L347.695743,157.258541 C348.451646,156.455395 349.505623,156 350.608543,156 Z"
      id="Rectangle-2-Copy-16"
    ></path>
  </g>
</svg>
<span class="tag__text">{{ tagName() }}</span>
